"use client";

import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  speed?: number;
  className?: string;
};

export function Marquee({ children, speed = 50, className = "" }: Props) {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <div className={`flex gap-12 overflow-hidden ${className}`}>{children}</div>
    );
  }
  return (
    <div className={`overflow-hidden ${className}`}>
      <motion.div
        className="flex gap-12 w-max"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {children}
        {children}
      </motion.div>
    </div>
  );
}
